module.exports = __webpack_public_path__ + "static/media/0028_IMG_LA_BVP_DES_SAVEURS.7534cd46.webp";